export const SITE = {
  name: "Swift Luxury Walls",
  tagline: "Premier Custom Entertainment Creations",
  phone: "813-449-1138",
  phoneDigits: "8134491138",
  email: "Rob@swiftluxurywalls.com",
  serviceArea: ["Tampa", "Brandon", "Riverview", "Land O' Lakes", "Clearwater", "St. Petersburg", "Sarasota", "Bradenton"],
  logo: "https://customer-assets.emergentagent.com/job_7e8193e0-edce-43f5-a1f7-0a85ea9e900a/artifacts/j0n8bmmw_image.png",
};

export const HERO_BG =
  "https://customer-assets.emergentagent.com/job_7e8193e0-edce-43f5-a1f7-0a85ea9e900a/artifacts/c2n84gqg_image.png";

export const PROJECT_PHOTOS = {
  mediaWall: "https://customer-assets.emergentagent.com/job_7e8193e0-edce-43f5-a1f7-0a85ea9e900a/artifacts/c2n84gqg_image.png",
  slatKitchen: "https://customer-assets.emergentagent.com/job_7e8193e0-edce-43f5-a1f7-0a85ea9e900a/artifacts/1gskg3s8_image.png",
  marbleInstall: "https://customer-assets.emergentagent.com/job_7e8193e0-edce-43f5-a1f7-0a85ea9e900a/artifacts/jqsyd5xi_image.png",
};

export const PLACEHOLDER_PHOTOS = {
  woodSlat: "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx3b29kJTIwc2xhdCUyMHdhbGwlMjBtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODA0MjYwODN8MA&ixlib=rb-4.1.0&q=85",
  marble: "https://images.pexels.com/photos/9976125/pexels-photo-9976125.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  homeTheater: "https://images.unsplash.com/photo-1773867567736-9ded7ecf680d?fm=jpg&q=85&w=1400&auto=format&fit=crop",
};

// Real completed installs with client testimonials attached to each photo.
export const COMPLETED_PROJECTS = [
  {
    id: "condo-marble-slat",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_luxury-walls-preview/artifacts/9c1hbkq3_image.webp",
    title: "High-Rise Media Wall",
    materials: "Marble panel · Black slat pillars · Floating console · Recessed lighting",
    city: "Tampa condo",
    quote:
      "Rob's team turned our high-rise living room into the exact statement we imagined. The slat pillars framing the marble panel look better in person than any render we saw. Install was tidy — protective coverings everywhere, cables completely invisible, done in three days.",
    client: "Elena & Marcus R.",
    role: "Downtown Tampa",
  },
  {
    id: "warm-travertine-slat",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_luxury-walls-preview/artifacts/9dzpi771_803683359_1431541392222137_4788706743518853217_n.webp",
    title: "Stone Veneer & Walnut Slat Media Wall",
    materials: "Custom media wall featuring textured stone veneer, warm wood slat accents, a floating console, and integrated LED lighting.",
    city: "Riverview",
    quote:
      "We wanted something warm and modern — the Panel Décor stone veneer with the walnut slats and hidden LED wash at the crown was exactly it. Swift nailed the proportions, and the concealed lighting is the detail every guest comments on first.",
    client: "Sanjay P.",
    role: "Riverview homeowner",
  },
  {
    id: "rgb-fireplace-media",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_luxury-walls-preview/artifacts/z4b6s8vu_801667425_1395832261961826_6477604479145571270_n.webp",
    title: "Color-Changing Media Wall + Fireplace",
    materials: "Textured stone veneer center · Slat wings · Color-changing LED · Linear electric fireplace",
    city: "Brandon",
    quote:
      "The kids love the color-changing lights, my wife loves the stone veneer, I love the fireplace. Rob designed the whole wall around our staircase and made it feel intentional — not squeezed in.",
    client: "Chris & Nicole D.",
    role: "Brandon family home",
  },
  {
    id: "two-story-travertine",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_luxury-walls-preview/artifacts/qcq97hhc_801368841_1072990785366922_2135911247433527635_n.webp",
    title: "Two-Story Great Room Feature",
    materials: "Full-height Panel Décor stone veneer · Walnut TV cladding · Full-height slat run",
    city: "Sarasota",
    quote:
      "Two-story great room, blank canvas — Swift proposed the stone veneer layout and the walnut TV panel and it transformed the room. The detail work on the vertical slat run is exceptional.",
    client: "Dr. Patel",
    role: "Sarasota residence",
  },
];

export const SERVICES = [
  {
    key: "media-walls",
    title: "Media Walls",
    desc: "Floating, integrated entertainment centerpieces engineered around your TV, sound and storage.",
    icon: "Tv",
  },
  {
    key: "accent-walls",
    title: "Accent Walls",
    desc: "Statement walls in stone, slat or paneling — a curated focal point for any room.",
    icon: "Layers",
  },
  {
    key: "entertainment-centers",
    title: "Entertainment Centers",
    desc: "Custom-built cabinetry, hidden storage and seamless cable management.",
    icon: "MonitorPlay",
  },
  {
    key: "feature-walls",
    title: "Feature Walls",
    desc: "One-of-a-kind installations designed around your space, materials and lifestyle.",
    icon: "Sparkles",
  },
  {
    key: "slat-walls",
    title: "Slat Walls",
    desc: "Modern decorative slat panels in wood, MDF or composite for warmth and depth.",
    icon: "AlignVerticalSpaceBetween",
  },
  {
    key: "led-lighting",
    title: "LED Lighting Integration",
    desc: "Backlit niches, cove lighting and ambient glow — wired clean, dimmed to taste.",
    icon: "Lightbulb",
  },
  {
    key: "stone-features",
    title: "Stone Features",
    desc: "Natural and engineered stone — marble, quartzite, porcelain slabs — fitted with precision.",
    icon: "Gem",
  },
  {
    key: "custom-shelving",
    title: "Custom Shelving Systems",
    desc: "Floating shelves and modular display systems built to your dimensions.",
    icon: "BookOpen",
  },
];

export const PROCESS = [
  { n: "01", title: "Consultation", desc: "We meet on-site, listen to your vision and measure your space." },
  { n: "02", title: "Design", desc: "Concepts, materials and 3D references — refined until it feels right." },
  { n: "03", title: "Build", desc: "Precision fabrication and installation by our in-house craftsmen." },
  { n: "04", title: "Reveal", desc: "A finished focal point you'll be proud to live with — guaranteed." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Rob and his team transformed our living room into something out of a magazine. The slat detail, the marble, the lighting — every inch is precise.",
    name: "Marcus & Elena R.",
    role: "Homeowners, Tampa",
  },
  {
    quote:
      "We hired Swift for our showroom feature wall. Communication was outstanding and the install was flawless. Clients comment on it every day.",
    name: "Jordan P.",
    role: "Interior Designer, St. Petersburg",
  },
  {
    quote:
      "Top-tier craftsmanship. They treated our home like their own and delivered ahead of schedule. Worth every dollar.",
    name: "Priya S.",
    role: "Property Investor, Clearwater",
  },
];
